import { render, staticRenderFns } from "./MotoDetailsIcon.vue?vue&type=template&id=53b06e4d&"
import script from "./MotoDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./MotoDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports